module.exports = __webpack_public_path__ + "img/convenios.7f44596e.png";